import React, { useEffect, useMemo } from 'react';
import useStudioExplain from '@home/hooks/useStudioExplain';
import MetricsCardWrap from '@/pages/dashboard/components/MetricsCardWrap';
import Gpt, { useKeyOpinionPromptList } from '@op/components/GPT';
import { getKeyOpinionHighGameGPTReport } from '@op/services/keyOpinions';
import { useRequestStats } from '@op/pages/feeds/hooks/useFeedsRequest';
import { openWithParams } from '@/pages/dashboard/utils/utils';
import classNames from 'classnames';
import './index.scss';
import Abnormal from '@home/components/Abnormal';

const AISummaryCard = (props: any) => {
  const {
    titleEn,
    titleCn,
    className='dbh-studio-home-key-opinion-card',
    style,
    titleEnChange,
    titleCnChange,
    isRightCard,
    isLeftCard,
    imgUrl,
    dodData,
    formatRule,
    titleFormatRule,
    metricKey,
    preUnit: unit,
    endUnit: unitEnd,
    isIconTips = false,
    rainbowKey,
    explainEn,
    explainCn,
    trendConfig,
    link,
    isSingle,
    cardType,
    yAxisNameEn,
    yAxisNameCn,
    filter,
    extraParams,
    gameInfo,
    ...restConfig
  } = props || {};

  // 获取七彩石指标注释
  const { tipEn, tipCn } = useStudioExplain(rainbowKey, explainEn, explainCn);
  // 根据 isSingle 动态修改 titleEn 和 titleCn
  const titleEN = isSingle ? titleEn : (titleEnChange || titleEn);
  const titleCN = isSingle ? titleCn : (titleCnChange || titleCn);
  // 筛选器参数
  const { filterParams } = useMemo(() => {
    const { start_time: startTime, end_time: endTime, date_type: dateType } = filter;
    return {
      filterParams: {
        start_time: startTime,
        end_time: endTime,
        date_type: dateType,
        sentiment_type: "total",
        ...gameInfo,
        ...extraParams
      }
    };
  }, [filter, extraParams, gameInfo]);
  // 请求stats数据来填充提示词
  useEffect(() => {
    requestState({
      ...filterParams,
      is_valid: [2,1,3]
    });
  }, [filterParams]);
  // 提示词数据、状态
  const { feedsStats, feedsStatsLoading, requestState } = useRequestStats({
    defaultLoading: true,
  });
  // 获取提示词
  const keyOpinionsPromptList = useKeyOpinionPromptList({
    gameInfo,
  });
  // 高级报告请求
  // 舆情逻辑，只有日期是单天才调用高级报告
  const requestFuncMap = useMemo(() => {
    if (!filterParams) return undefined;
  
    return {
      defaultRequest: (filter: any) => {
        const { start_time, end_time, sentiment_type, date_type } = filter;
  
        const oriFilter = {
          start_time,
          end_time,
          sentiment_type,
          channel_type: "total",
          date_type,
          ...gameInfo
        };
        return getKeyOpinionHighGameGPTReport(oriFilter).then((data) => data);
      },
    };
  }, [filterParams, gameInfo]);
  // 卡片跳转
  const onClick = () => {
    if (link) {
      openWithParams(link, filterParams);
    }
  };

  return (
    <MetricsCardWrap
      titleCn={titleCN}
      titleEn={titleEN}
      className={classNames(className,"dbh-studio-home-rank-card card-slot")}
      style={style}
      titleLink={link ? onClick : null}
      tipsEn={tipEn}
      tipsCn={tipCn}
      imgUrl={imgUrl}
      isIconTips={isIconTips}
      {...restConfig}
    > 
      <Abnormal
        isLoading={feedsStatsLoading}
        isError = {!feedsStats}
        style={{height: "250px"}}
        component={      
          <Gpt.PageCard
            filter={filterParams}
            gameInfo={gameInfo}
            wholeGameInfo={gameInfo}
            hasStopBtn={true}
            requestFuncMap={requestFuncMap}
            autoRequest={false}
            contentCard
            promptList={keyOpinionsPromptList}
            oriFeedsState={feedsStats}
            linkFilterChange={false}
            showModelType={false}
            loadingHeight={320}
            isShowTitle={false}
            title={" "}
          >
            {(toggleVisible: any, { total }: { total: number; }) => (
              <div className="gpt-summary-entry-tips">
                <Gpt.Button
                  disabled={total <= 0}
                  onClick={() => toggleVisible()}
                ></Gpt.Button>
              </div>
            )}
          </Gpt.PageCard>}
      >
      </Abnormal>
    </MetricsCardWrap>
  );
};

export default AISummaryCard;